import React from "react";
import { Link } from "react-router-dom";
import { BadgeEnvironnement } from "./environnement";

// Sous 992 px : barre haute avec le bouton du tiroir, le logo et le titre de
// l'entrée courante ; hors production, le badge d'environnement suit le logo.
// `actions` : la cloche des notifications, en bout de barre.
const BarreHauteMobile = ({ ouvert, onOuvrir, titre, badge = null, refBouton, actions = null }) => (
  <header className="barre-haute">
    <button
      ref={refBouton}
      type="button"
      className="menu-lateral__bouton"
      aria-label="Ouvrir le menu"
      aria-controls="menu-lateral"
      aria-expanded={ouvert}
      onClick={onOuvrir}
    >
      <i className="fa fa-bars" aria-hidden="true" />
    </button>
    <Link to="/dashboard" className="barre-haute__accueil">
      <img src="/images/logo_white.png" alt="Perceval, accueil" />
      <BadgeEnvironnement badge={badge} />
    </Link>
    {titre && <span className="barre-haute__titre">{titre}</span>}
    {actions}
  </header>
);

export default BarreHauteMobile;
